import { render } from "./comp-empty.vue?vue&type=template&id=0f3c0a7e&ts=true"
import script from "./comp-empty.vue?vue&type=script&lang=ts"
export * from "./comp-empty.vue?vue&type=script&lang=ts"

import "./comp-empty.vue?vue&type=style&index=0&id=0f3c0a7e&lang=less"

import exportComponent from "/usr/local/share/applications/yushifu-shop-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__